/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

type SalesDashboardPrimaryButtonProps =
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children: React.ReactNode;
  };

export const SalesDashboardPrimaryButton: React.FC<
  SalesDashboardPrimaryButtonProps
> = ({ children, type = "button", ...props }) => (
  <button {...props} css={styles.button} type={type}>
    {children}
  </button>
);

const styles = {
  button: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 38px;
    padding: 9px 18px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.4px;
    background-color: #00c2ae;
    border: 1px solid #00c2ae;
    border-radius: 8px;
    transition:
      background-color 150ms ease-in-out,
      border-color 150ms ease-in-out;
    cursor: pointer;
    &:hover:not(:disabled) {
      background-color: #33d6c4;
      border-color: #33d6c4;
    }
    &:focus-visible {
      outline: 2px solid #00c2ae;
      outline-offset: 2px;
    }
    &:disabled {
      cursor: default;
      opacity: 0.6;
    }
  `,
};
